<content id="big-modal">
    <section>
        <h2>{{'mantenimientoVersionesEtiquetado.modal.asociarActualizaciones.titulo' | translate}}</h2>
        <form [formGroup]="actualizacionesForm">
            <div class="entry-3-modal">
                <label>{{'global.pais' | translate}}</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="actualizacionesForm.get('pais')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-3-modal">
                <label>{{'mantenimientoVersionesEtiquetado.modal.asociarActualizaciones.denominaciones' | translate}}</label>
                <app-multiselect-list  [itemsList]="denominaciones ? denominaciones : []"
                    (shareCheckedList)="shareCheckedListDenominaciones($event)"
                    [selectedItem]="actualizacionesForm.get('denominaciones')" [disabled]="disabledDenominaciones"
                    [initialState]="'noSelected'">
                </app-multiselect-list>
            </div>
        </form>
    </section>
    <section style="margin-top: .5em;">
        <table>
            <thead>
                <tr>
                    <th class="sort">{{'global.pais' | translate}}</th>
                    <th class="sort">{{'mantenimientoVersionesEtiquetado.modal.asociarActualizaciones.denominacion' | translate}}</th>
                </tr>
            </thead>
            <tbody *ngFor="let actualizacion of actualizacionesString; let i=index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="sort">{{actualizacion.pais}}</td>
                    <td class="sort">{{actualizacion.denominacion}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2">
                        <app-paginator *ngIf="actualizacionesString && actualizacionesString.length > 0" [itemsPerPage]="itemsPerPage"
                            [currentPage]="currentPage" [totalItems]="totalItems" [visiblePages]="visiblePages" [hiddeItems]="true"
                            (pageChange)="pageChange($event)"></app-paginator>
                    </td>
                </tr>
            </tfoot>
        </table>
    </section>
</content>